import { styled } from "styled-components";

export const SignUpInputTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
